import Layout from "../include/layout";
import { Button } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import dayjs from 'dayjs'
import { Link, useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import Swal from "sweetalert2";
import { checkAuthenticate } from "../app/providers/authSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import 'datatables.net-bs5'
import HabilitationsService from "./HabilitationsService";
import Filarial from "../include/filarial";

export default function HabilitationIndex() {
    const activeLink = "HABILITATIONS"

    const token = useSelector(state => state.auth.token)
    const [habilitations, setHabilitations] = useState([])
    const navigate = useNavigate()
    //check if user is authenticated
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(state => state.auth.isAuthenticate)

    //get liste statuts
    const fetchHabilitations = async () => {
        await HabilitationsService.index(token).then((res) => {
            //console.log(res.data.data)
            setHabilitations(res.data.data)
        }).catch(error => {
            console.log(error)
        })

        //initialize datatable
        $(document).ready(function () {
            $('.data-table').DataTable();
        });
    }

    //redirection sur la page edit sans afficher les id dans l'url
    const goToEdit = (param) => {
        navigate(myroutes.roles_edit, { state: { id: param } })
    }

    //suppression d'un élément
    const onDelete = (param) => {
        //confirm action
        Swal.fire({
            icon: "warning",
            text: "Voulez-vous confirmer cette action ?",
            showCancelButton: true,
            cancelButtonText: "Non",
            confirmButtonText: "Oui",
            confirmButtonColor: "red"
        }).then(result => {
            if (result.isConfirmed) {
                HabilitationsService.delete(param, token).then((response) => {
                    //console.log(response.data)
                    if (response.data.status !== 200) {
                        Swal.fire({
                            icon: "error",
                            text: response.data.message
                        })
                    } else {
                        Swal.fire({
                            icon: "success",
                            text: response.data.message
                        })
                        fetchHabilitations()
                    }
                }).catch(e => {
                    Swal.fire({
                        icon: "error",
                        text: e.message
                    })
                    console.log(e)
                })
            }
        })
    }

    useEffect(() => {
        fetchHabilitations();
        // Vérifier si l'utilisateur est connecté lors du chargement de l'application
        dispatch(checkAuthenticate());
        if (!isAuthenticated) {
            //console.log(isAuthenticated)
            //Redirection sur le dashboard
            navigate(myroutes.login)
        }
    }, [dispatch])


    return (
        <Layout>
            <div className="container-xxl flex-grow-1 container-p-y">
            <Filarial activeLink={activeLink} />

                {/* Responsive Datatable */}
                <div className="card shadow-lg mb-3 mt-3">
                    <h5 className="card-header">Liste des habilitations <Link className="btn btn-primary btn-sm"
                        to={myroutes.habilitations_create} title="Ajouter">
                        <FontAwesomeIcon icon="fa-solid fa-circle-plus" /></Link></h5>
                    <div className="card-datatable table-responsive px-4 pb-3">
                        <table className="dt-responsive table border-top data-table table-hover ">
                            <thead className="bg-primary">
                                <tr style={{ color: "white" }}>
                                    <th className="cell text-white">#</th>
                                    <th className="cell text-white">Rôle</th>
                                    <th className="cell text-white">Create</th>
                                    <th className="cell text-white">Read</th>
                                    <th className="cell text-white">Update</th>
                                    <th className="cell text-white">Delete</th>
                                    <th className="cell text-white">Moved</th>
                                    <th className="cell text-white">Statut</th>
                                    <th className="cell text-white">Date modification</th>
                                    <th className="cell text-white">Modifié par</th>
                                    <th className="cell text-white">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {habilitations.length > 0 && habilitations.map((item, index) => (
                                    <tr key={index}>
                                        <td className="cell">{index + 1}</td>
                                        <td className="cell">{item.libelleRole} </td>
                                        <td className="cell">{item.created} </td>
                                        <td className="cell">{item.readed} </td>
                                        <td className="cell">{item.updated} </td>
                                        <td className="cell">{item.deleted} </td>
                                        <td className="cell">{item.moved} </td>
                                        <td className="cell">
                                            <span class={item.statuts?.libelleStatut === "ACTIF" ? 'badge rounded-pill bg-success' : 'badge rounded-pill bg-warning'}>{item.statuts?.libelleStatut}</span>
                                        </td>
                                        <td className="cell">
                                            <span>{dayjs(item.updatedAt).format("DD/MM/YYYY H:m:s")}</span>
                                        </td>
                                        <td className="cell">{item.updatedBy?.nom + " "+ item.updatedBy?.prenoms} </td>
                                        <td className="cell">
                                            <Button className="btn btn-sm" variant="primary" onClick={() => goToEdit(item.id)}
                                                title="Modifier">
                                                <i className="fas fa-edit"></i></Button> &nbsp;&nbsp;
                                            <Button className="btn btn-sm" variant="danger" onClick={() => onDelete(item.id)}
                                                title="Supprimer">
                                                <i className="fas fa-trash"></i></Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                {/*/ Responsive Datatable */}
            </div>

        </Layout>
    )
}